import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'classesStudents.editStudent.editConfirmation.title',
    defaultMessage: 'STUDENT SAVED',
  },
  subtitle: {
    id: 'classesStudents.editStudent.editConfirmation.subtitle',
    defaultMessage: 'Student was saved successfully',
  },
  continue: {
    id: 'classesStudents.editStudent.editConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
